import { jsx, jsxs } from "react/jsx-runtime";
import { getFirstCharacter } from "@tldraw/editor";
import { PORTRAIT_BREAKPOINT } from "../../constants.mjs";
import { useBreakpoint } from "../../context/breakpoints.mjs";
import { useTldrawUiComponents } from "../../context/components.mjs";
function DefaultPeopleMenuFacePile({
  userIds,
  userName,
  userColor
}) {
  const { PeopleMenuAvatar } = useTldrawUiComponents();
  const breakpoint = useBreakpoint();
  const maxAvatars = breakpoint <= PORTRAIT_BREAKPOINT.MOBILE_XS ? 1 : 5;
  return /* @__PURE__ */ jsxs("div", { className: "tlui-people-menu__avatars", children: [
    PeopleMenuAvatar && userIds.slice(-maxAvatars).map((userId) => /* @__PURE__ */ jsx(PeopleMenuAvatar, { userId }, userId)),
    userIds.length > 0 && /* @__PURE__ */ jsx(
      "div",
      {
        className: "tlui-people-menu__avatar",
        style: {
          backgroundColor: userColor
        },
        children: getFirstCharacter(userName ?? "")
      }
    ),
    userIds.length > maxAvatars && /* @__PURE__ */ jsx("div", { className: "tlui-people-menu__avatar tlui-people-menu__more", children: Math.abs(userIds.length - maxAvatars) })
  ] });
}
export {
  DefaultPeopleMenuFacePile
};
//# sourceMappingURL=DefaultPeopleMenuFacePile.mjs.map
